import { ref, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';

export const useQueryParams = () => {
  const router = useRouter();
  const route = useRoute();

  const queryParams = ref({ ...route.query });

  const setQuery = (key: string, value: string) => {
    queryParams.value = { ...queryParams.value, [key]: value };
    updateRoute();
  };

  const removeQuery = (key: string | string[]) => {
    if (Array.isArray(key)) {
      key.forEach((k) => {
        const { [k]: removed, ...rest } = queryParams.value;
        queryParams.value = rest;
      });
    } else {
      const { [key]: removed, ...rest } = queryParams.value;
      queryParams.value = rest;
    }
    updateRoute();
  };

  const resetQuery = () => {
    queryParams.value = {};
    updateRoute();
  };

  const updateRoute = () => {
    router.push({ query: queryParams.value });
  };

  watch(
    () => route.query,
    (newQuery) => {
      queryParams.value = { ...newQuery };
    }
  );

  return {
    queryParams,
    setQuery,
    removeQuery,
    resetQuery
  };
};
